import { Link } from 'react-router';

import { useSwitchNumberCount } from '../hooks/useSwitchNumberCount';

interface SharedSwitchBannerProps {
  switchId: string;
  /** The switch's Numbers tab */
  numbersHref: string;
}

/** Warns, on a shared switch, that forwarding changes apply to every number using it. */
const SharedSwitchBanner = ({ switchId, numbersHref }: SharedSwitchBannerProps) => {
  const { count, isShared } = useSwitchNumberCount(switchId);

  if (!isShared) return null;

  return (
    <div
      role="status"
      className="flex gap-3 items-start px-4 py-3 text-sm rounded-md border text-amber-700 dark:text-amber-400 border-amber-300 dark:border-amber-600 bg-amber-50 dark:bg-amber-900/20"
    >
      <span className="material-symbols-outlined">warning</span>
      <p>
        <strong>
          This switch is used by {count !== null ? `${count} numbers` : 'multiple numbers'}.
        </strong>{' '}
        Changes to forwarding here apply to all of them.{' '}
        <Link to={numbersHref} className="underline">
          View numbers
        </Link>
      </p>
    </div>
  );
};

export default SharedSwitchBanner;
